<template>
  <b-container id="successful-Leaders" class="text-center">
    <b-row>
      <b-col>
        <h3><b>Successful leaders are effective communicators</b></h3>
        <p>
          The most productive way to build your career is to build your
          presentation skills
        </p>
        <TMGeneralButton
          text="START TO RECEIVE FEEDBACK"
          route="GetStarted"
          className="blue"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import TMGeneralButton from "@/components/common/TMGeneralButton";
export default {
  name: "SuccessfulLeaders",
  components: {
    TMGeneralButton,
  },
};
</script>
<style lang="less">
@import "../../assets/components/home/SuccessfulLeaders.less";
</style>



